export const SOCIALS = [
    {
        type: 'instagram',
        url: 'https://www.instagram.com/jarek_skurzynski/',
    },
];
